import { applyMiddleware, createStore } from "redux";
import { thunk } from "redux-thunk";
import { reducers } from "./reducer/";

const store = createStore(reducers, applyMiddleware(thunk));

export default store;



// import { configureStore } from "@reduxjs/toolkit";

// import TenantnReducer from "./reducer/TenantSlice";

// import cmsManagementReducer from "./reducer/cmsManagementSlice";
// import NotificationReducer from "./reducer/NotificationSlice";


// export const store = configureStore({
//   reducer: {
   
//     tenant: TenantnReducer,

//     cmsManagement: cmsManagementReducer,
//     notification: NotificationReducer,
   
//   },
// });

// export default store;
